import React from 'react';
import styled from '@emotion/styled';

const AlertWrapper = styled.div`
  width: 100%;
  padding: 10px;
  color: #7d7c7c;
  border: 1px solid #f2f2f2;
  background-color: #fdfbfb;
  margin-bottom: 10px;
  text-align: center;
  h3 {
    color: #7d7c7c;
    margin: 10px 0 20px;
  }
  button {
    margin-bottom: 10px;
  }
`;

interface AlertProps {
  show?: boolean;
  children: React.ReactNode;
}

const Alert = (props: AlertProps) => {
  if (!props.show) {
    return null;
  }

  return <AlertWrapper>{props.children}</AlertWrapper>;
};

export default Alert;
